import { render } from "./FlipPhone.vue?vue&type=template&id=21da4cab&scoped=true"
import script from "./FlipPhone.vue?vue&type=script&lang=js"
export * from "./FlipPhone.vue?vue&type=script&lang=js"

import "./FlipPhone.vue?vue&type=style&index=0&id=21da4cab&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21da4cab"]])

export default __exports__